import { useStore } from '@/store';
import {
  ChannelAgreementReturnType,
  CreateTicketOrderParamsType,
  GetGoodsListReturnType,
  GetLoginMethodReturnType,
  GetOrderDetailReturnType,
  GetPayDiscountPriceParamsType,
  GetPayDiscountPriceReturnType,
  GetPayPrivilegeInfoParamsType,
  GetPayPrivilegeInfoResultType,
  GetSeatMapReturnType,
  GetUnpaidOrderListReturnType,
  LockSeatsReturnType,
  QueryCouponInfoListParamsType,
  QueryCouponInfoListReturnType,
  TaoBaoResponseType,
  GetScreenReturnType,
  GetCardDetailParamsType,
  GetCardDetailReturnType,
  GetCardRuleDetailType,
  GetCardRulesReturnType,
  GetOrderListReturnType,
  GetPayMethodReturnType,
  GetScheduleInfoReturnType,
  GetAccountLevelRulesReturnType,
  GetCardListReturnType,
} from '@/types';
import { cans } from '@/utils';
import request, { requestCustomType } from './index';
import { isMpay } from '@/hooks/otherLogin/Mapy/mpayConfig';
import { GetHotFilmReturnType, GetSoonFilmsReturnType, GetUserInfoReturnType } from '@/types/home';
import { GetFilmDetailReturnType } from '@/types/file';
import { GetAdvertsReturnType, GetCinemaCurrencySignReturnType } from '@/types/cinema/detail';

export default {
  // 获取场次
  async getTest(params: any) {
    return await request(params);
  },
  async sendCaptcha(params: {
    type: any;
    mobileOrEmail: any;
    mode: string;
    mobileCountryCode: string;
    dataRiskParam: string;
  }) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.notify.sendCaptcha',
      data: {
        ...params,
      },
    };
    return await request(tempParams);
  },

  async getScreen() {
    const tempParams = {
      api: 'gop.alipic.icirena.own.schedule.getSchedules',
      data: {},
    };
    return await request<GetScreenReturnType>(tempParams);
  },
  async getFilmDetail(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.film.getFilmDetail',
      data: {
        ...params,
      },
    };
    return await request<GetFilmDetailReturnType>(tempParams);
  },

  async getSeatMap() {
    const store = await useStore.getState();
    const { orderObj } = store;

    const { scheduleId, scheduleKey, hallId } = orderObj.schedule;
    const getSeatMapParms = {
      api: 'gop.alipic.icirena.own.seat.getSeatMap',
      data: {
        scheduleId,
        scheduleKey,
        hallId,
      },
    };

    return await request<GetSeatMapReturnType>(getSeatMapParms);
  },

  async authGuestLogin() {
    const tempParams = {
      api: 'gop.alipic.icirena.own.auth.login2',
      data: {
        type: 'GUEST',
        principal: cans(),
      },
    };
    return await request(tempParams);
  },
  async checkWXisBind(data) {
    const tempParams = {
      api: 'gop.alipici.cirena.own.auth.checkThirdCountRegistered',
      data: {
        ...data,
      },
    };
    return await request(tempParams);
  },
  async lockSeats(data: any) {
    const store = await useStore.getState();
    const { orderObj } = store;
    const { scheduleId, scheduleKey, hallId } = orderObj.schedule;
    const param = {
      api: 'gop.alipic.icirena.own.seat.lockSeats',
      data: {
        scheduleId,
        scheduleKey,
        hallId,
        ...data,
      },
    };
    return await request<LockSeatsReturnType>(param);
  },

  async unLockSeats(data: any) {
    const param = {
      api: 'gop.alipic.icirena.own.seat.unlockSeats',
      data: {
        ...data,
      },
    };
    return await request(param);
  },

  async getHotFilm(param: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.film.getHotFilms',
      data: {
        ...param,
        posterSize: 'SMALL',
      },
    };
    return await request<GetHotFilmReturnType[]>(tempParams);
  },

  async getSoonFilms(param: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.film.getSoonFilms',
      data: {
        ...param,
        posterSize: 'SMALL',
      },
    };
    return await request<GetSoonFilmsReturnType[]>(tempParams);
  },
  async getUserInfo(param) {
    const tempParms = {
      api: 'gop.alipic.icirena.own.account.getAccountId',
      data: {
        ...param,
      },
    };
    return await request<GetUserInfoReturnType>(tempParms);
  },
  async getMemberRightSwitch(param) {
    const tempParms = {
      api: 'gop.alipic.icirena.own.account.getMemberRightSwitch',
      data: {
        ...param,
      },
    };
    return await request(tempParms);
  },
  async authLogOff(param) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.auth.logoutAccount',
      data: {
        ...param,
      },
    };
    return await request(tempParams);
  },
  /**
   * getCouponList 获取我的优惠券列表
   * @returns {*}
   */
  async getCouponList(param) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.coupon.getMyOnlineCoupons',
      data: {
        ...param,
      },
    };
    return await request(tempParams);
  },
  /**
   * getCouponCount 获取优惠券分类数量
   * @returns {*}
   */
  async getCouponCount(param) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.coupon.getMyOnlineCouponsCount',
      data: {
        ...param,
      },
    };
    return await request(tempParams);
  },
  /**
   * 获取优惠券详情
   * @param couponCode
   * @returns {*}
   */
  async getCouponDetail(param) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.coupon.getCouponDetail',
      data: {
        ...param,
      },
    };
    return await request(tempParams);
  },
  async updateAccountInfo(param) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.account.updateAccountInfo',
      data: {
        ...param,
      },
    };
    return await request(tempParams);
  },
  /**
   * 积分商城，获取兑换商品的订单详情
   * @param orderId
   * @returns {*}
   */
  async getStoreOrderDetail(param) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.istore.getMerchandiseOrderDetail',
      data: {
        ...param,
      },
    };
    return await request(tempParams);
  },
  async getAccountLevelRules(param) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.account.getAccountLevelRules',
      data: {
        ...param,
      },
    };
    return await request<GetAccountLevelRulesReturnType>(tempParams);
  },
  async getSid() {
    const { baseObj } = useStore.getState();
    const { tid } = baseObj.user;
    const tempParms = {
      api: 'gop.alipic.icirena.own.auth.getSidByTid',
      data: {
        tid: tid,
      },
    };
    return await request(tempParms);
  },
  async cancelOrder(params: { orderId: string; orderType: string }) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.order.cancelOrder',
      data: {
        ...params,
      },
    };
    return await request(tempParams);
  },
  async authLogin(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.auth.login2',
      data: {
        ...params,
      },
    };
    return await request(tempParams);
  },

  async request(config) {
    config.isRequest = true;
    return await request(config);
  },
  /**
   * 获取支付方式 / 兑现优惠卷
   */
  async getPayPrivilegeInfo(params: GetPayPrivilegeInfoParamsType) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.pay.getPayPrivilegeInfo',
      data: {
        ...params,
      },
    };
    if (isMpay()) {
      tempParams.data.platform = 'MPayMiniProgram';
    }
    // if (isWeChat()) {
    //   tempParms.data.platform = 'wechat'
    // }
    // if (isTFB()) {
    //   tempParms.data.platform = 'TaifungPayMiniProgram';
    // }
    return await request<GetPayPrivilegeInfoResultType>(tempParams);
  },
  /**
   * 创建支付订单
   */
  async createTicketOrder(params: CreateTicketOrderParamsType) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.order.createTicketOrder',
      data: params,
    };

    return await request(tempParams);
  },
  /**
   * payOrder 订单详情-更改支付方式再次下单
   */
  async payOrder(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.order.payOrder',
      data: params,
    };
    return await request(tempParams);
  },
  /**
   * 获取订单详情
   */
  async getOrderDetail(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.order.getOrderDetail',
      data: params,
    };
    return await request<GetOrderDetailReturnType>(tempParams);
  },
  async getOrderDetailNoSid(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.order.getOrderDetailNoSid',
      data: params,
    };
    return await request<GetOrderDetailReturnType>(tempParams);
  },
  /**
   * 兑换aia劵
   */
  async getPayDiscountPrice(params: GetPayDiscountPriceParamsType) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.pay.getPayDiscountPrice',
      data: params,
    };
    return await request<GetPayDiscountPriceReturnType>(tempParams);
  },

  async getCinemaCurrencySign(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.cinema.getCinemaCurrencySign',
      data: {
        ...params,
      },
    };
    return request<GetCinemaCurrencySignReturnType[]>(tempParams);
  },
  async getCinemas() {
    const tempParams = {
      api: 'gop.alipic.icirena.own.cinema.getCinemas',
      data: {},
    };
    return request(tempParams);
  },
  async queryCouponInfoList(params: QueryCouponInfoListParamsType) {
    const tempParams = {
      api: 'taobao.icirena.pos.coupon.querycouponinfolist',
      data: {
        empCode: '',
        cinemaLinkId: '',
        channelCode: '',
        larkSid: '',
        version: '',
        appVersion: '',
        ...params,
      },
    };
    return requestCustomType<TaoBaoResponseType<QueryCouponInfoListReturnType>>(tempParams);
  },
  async getOrderList(params: {}) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.order.getOrderList',
      data: {
        ...params,
      },
    };
    return await request<GetOrderListReturnType[]>(tempParams);
  },

  async getGoodsList(params = {}) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.goods.getNewGoodses',
      data: {
        ...params,
      },
    };
    return await request<GetGoodsListReturnType>(tempParams);
  },

  async axios(config: { isRequest: boolean }) {
    config.isRequest = true;
    return await request(config);
  },

  /**
   * 获取场次信息
   * @param params
   */
  async getScheduleInfo(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.schedule.getScheduleInfo',
      data: {
        ...params,
      },
    };
    return await request<GetScheduleInfoReturnType>(tempParams);
  },

  /**
   * 获取渠道协议
   * @param params
   */
  async channelAgreement(params: { type: string }) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.lease.channelAgreement',
      data: {
        ...params,
      },
    };
    return await request<ChannelAgreementReturnType[]>(tempParams);
  },

  /**
   * 获取待支付订单
   * @param params
   */
  async getUnpaidOrderList() {
    const tempParams = {
      api: 'gop.alipic.icirena.own.order.getUnpaidOrderList',
      data: {},
      type: 'POST',
      query: {},
    };
    return await request<GetUnpaidOrderListReturnType[]>(tempParams);
  },
  /**
   * 获取可购买的会员卡列表
   * @param params
   */
  async getCardRules() {
    const tempParam = {
      api: 'gop.alipic.icirena.own.card.getCardRules',
      data: {},
    };
    return await request<GetCardRulesReturnType[]>(tempParam);
  },
  /**
   * 获取可购买的会员卡详情
   * @param params
   */
  async getCardRuleDetail(params) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.card.getCardRuleDetail',
      data: {
        ...params,
      },
    };
    return await request<GetCardRuleDetailType>(tempParam);
  },
  /**
   * 卡订单获取支付方式
   * @param params
   */
  async getPayMethod(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.pay.getPayMethod',
      data: {
        ...params,
      },
    };
    return await request<GetPayMethodReturnType>(tempParam);
  },
  /**
   * 获取用户会员卡列表
   * @param params
   */
  async getCardList(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.card.getCardList',
      data: {
        ...params,
      },
    };
    return await request<GetCardListReturnType[]>(tempParam);
  },

  /**
   * 储值卡开卡
   * @param params
   */
  async applyCard(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.order.applyCard',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },
  /**
   * 储值卡充值
   * @param params
   */
  async rechargeCardOrder(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.order.rechargeCardOrder',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },
  /**
   * 获取卡详情
   * @param params
   */
  async getCardDetail(params: GetCardDetailParamsType) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.card.getCard',
      data: {
        ...params,
      },
    };
    return await request<GetCardDetailReturnType>(tempParam);
  },
  /**
   * 储值卡续卡
   * @param params
   */
  async submitMembershipFeeOrder(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.order.submitMembershipFeeOrder',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },
  /**
   * 初次设置密码
   * @param cinemaLinkId 会员卡的影院
   */
  async initCardPassword(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.card.initCardPassword',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },
  /**
   * 获取登陆方式
   * @param params
   */
  async getLoginMethod(params: { leaseCode: string }) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.lease.loginMethod',
      data: {
        ...params,
      },
      type: 'POST',
      query: {},
    };
    return await request<GetLoginMethodReturnType>(tempParams);
  },
  /**
   * 获取MPaySDK配置
   * @param params
   */
  async getMpaySDKConfig(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.payment.mpaySignature',
      data: {
        ...params,
        url: window.location.href,
      },
      type: 'POST',
      query: {},
    };
    return await request(tempParam);
  },
  /**
   * 获取广告
   * @param params
   */
  async getAdverts(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.advert.getAdverts',
      data: {
        ...params,
      },
      type: 'POST',
      query: {},
    };
    return await request<GetAdvertsReturnType[]>(tempParams);
  },
  /**
   * 校验修改会员卡密码的验证码是否通过
   * @param params
   */
  async preVerifyCaptcha(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.notify.preVerifyCaptcha',
      data: {
        ...params,
      },
      type: 'POST',
      query: {},
    };
    return await request(tempParams);
  },
  /**
   * 修改会员卡密码
   * @param params
   */
  async resetCardPassword(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.card.resetCardPassword',
      data: {
        ...params,
      },
      type: 'POST',
      query: {},
    };
    return await request(tempParams);
  },
  /**
   * @description 获取短链
   * @param params
   */
  async getShortLink(params: any) {
    const tempParams = {
      api: 'gop.alipic.icirena.own.getRealurl',
      data: {
        ...params,
      },
      type: 'POST',
      query: {},
    };
    return await request(tempParams);
  },
  async getChannelSetting(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.channel.getChannelSetting',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },

  /**
   * 获取我的积分,消费列表
   * @param params
   */
  async getPointInfoList(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.account.getPointInfoList',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },

  /**
   * 获取我的积分商城信息
   * @param params
   */
  async getPointStoreInfo(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.istore.getMerchandiseList',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },

  /**
   * 获取我的积分商品详情
   * @param params
   */
  async getPointStoreDetailInfo(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.istore.getMerchandiseDetail',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },

  /**
   * 积分商品兑换
   * @param params
   */
  async confirmMerchandisesOrder(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.order.confirmMerchandisesOrder',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },

  /**
   * 获取积分兑换记录
   * @param params
   */
  async getPointStoreOrderList(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.istore.getMerchandiseOrderList',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },

  /**
   * 获取积分兑换订单详情
   * @param params
   */
  async getPointStoreOrderDetail(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.istore.getMerchandiseOrderDetail',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },

  /**
   * 获取积分兑换订单信息
   * @param params
   */
  async getPointStoreOrderInfo(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.order.getOrderInfo',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },

  /**
   * 退单
   * @param params
   */
  async refundPointStoreOrder(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.order.refundOrder',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },
  /**
   * @desc 用户绑定手机号/邮箱
   * @param data { channelCode , cinemaLinkId,larkSid,type,mobileCountryCode,mobileOrEmail,captcha }
   * @returns {Promise<Awaited<boolean|*>>|Promise<* | void>}
   */
  async bindMobileOrEmail(params = {}) {
    const tempParam = {
      api: 'gop.alipic.icirena.own.account.bindMobileOrEmail',
      data: {
        ...params,
      },
    };
    return await request(tempParam);
  },
  /**
   * 获取用户信息
   * @param
   */
  async getAccount() {
    const tempParam = {
      api: 'gop.alipic.icirena.own.account.getAccountId',
      data: {},
    };
    return await request<GetUserInfoReturnType>(tempParam);
  },
  /**
   * 获取用户信息
   * @param
   */
  async loginOut() {
    const tempParam = {
      api: 'gop.alipic.icirena.own.auth.logout',
      data: {},
    };
    return await request(tempParam);
  },
};
